import { BlockAnalyzed } from "./block-analyzed";
/**
 * Estende BlockAnalyzed per specificare il template dei links
 * Dati di esempio per i links
{
    "sito_ufficiale": "https://www.regione.lombardia.it/",
    "domanda_online": "https://portale.comune.milano.it/",
    "normativa": "https://www.gazzettaufficiale.it/"
}
 */
export class BlockAnalyzedLinks extends BlockAnalyzed {
    static override webComponentName: string = "block-analyzed-links";
    protected override _templateId: string = "block-analyzed-links";

    protected collectActualValue(): any {
        return this.value; // l'ambito non è modificabile dall'utente
    }

    protected isValidValue(value: any): boolean {
        return value != null && typeof value === 'object' && !Array.isArray(value);
    }

    private disableListItem(listItem: HTMLElement) {
        listItem.classList.add('disabled');
        listItem.setAttribute('aria-disabled', 'true');
        const button = listItem.querySelector('button');
        if (button) {
            button.setAttribute('tabindex', '-1');
            button.setAttribute('disabled', 'true');
        }
    }
    
    // questo applica tutti i valori all'input target  
    protected applyValueToTarget() {
        // i valori sono i territorial_id separati da virgola 
        const el = this.targetElement;
        if (el && typeof el['addLink'] === 'function') {
            const buttons = this.querySelectorAll('button[data-key]');
            buttons.forEach(button => {
                this.addSingleApplyButton(button as HTMLButtonElement);
            });
        }
        else {
            console.warn("BlockAnalyzedLinks: targetElement is not set or does not have addLink method.", el);
        }
    }
    // qui applica il singolo valore al target
    protected applyValue(key: string, url: string) {
        const el = this.targetElement;
        if (el && typeof el['addLink'] === 'function') {
            console.log(key, url);
            el['addLink'](key, url);
        }
        else {
            console.warn("BlockAnalyzedLinks: targetElement is not set or does not have addLink method.", el);
        }

    }
    private addSingleApplyButton(button: HTMLButtonElement | null) {
        const key = button.getAttribute('data-key');
        const url = button.getAttribute('data-value');
        if (key && url) {
            const listItem = button.closest('.list-group-item');
            console.log("addSingleApplyButton", listItem, key, url);
            if (listItem && !button.disabled) {
                this.applyValue(key, url);
                this.disableListItem(listItem as HTMLElement);
            }
        }
    }
    protected setupEventHandlers() {
        super.setupEventHandlers();
        // qui gestisce 
        this.on('click', 'button[data-key]', (e) => {
            const button = e.target as HTMLButtonElement;
            this.addSingleApplyButton(button);
        });
    }
}